





























































































import {
    Vue, Component, Prop,
} from 'vue-property-decorator'
import {State} from 'vuex-class'

@Component
export default class Page extends Vue {
    $refs: any

    height: any = 0

    @Prop({default: false}) transparent!: boolean   // 背景是否透明

    @State('collapseMenu') collapseMenu

    handleResize() {
        this.height = window.innerHeight - this.$refs.fixFooter.offsetHeight - this.$refs.fixTab.offsetHeight - 52 + 'px'
    }

    mounted(): void {
        this.handleResize()
    }
}
